import Class from './v-widget';
import './v-widget@.vue';

export default Class;